// This is using NUFC configs for the time being
export var STREAM_CONFIG = {
  partnerId: '3000780',
  uiconfId: '30018897',
  uiconfIdLiveAudio: '30021223',
  uiconfIdLiveStream: '30021223',
  paymentsApi: 'https://newcastlepayments.streamamg.com/_resx/js/stream-payments-02062017150421.js',
  geoCheckApi: '/umbraco/backoffice/custom-api/StreamPayment/GeoLookup',
  annualVideoSubscriptionEntitlement: 'livevideo',
  annualAudioSubscriptionEntitlement: 'liveaudio'
};
export var COOKIE_CONFIG = {
  cookiePolicy: 'c_policy',
  cookiePolicyExpirationDays: 60,
  xsrfRequestToken: 'XSRF-REQUEST-TOKEN'
};
export var CSS_CLASSES = {
  isActive: 'is-open',
  isOpen: 'is-open',
  isShowing: 'is-showing',
  navIsShowing: 'nav-is-showing',
  overlayIsShowing: 'overlay-is-showing'
};
export var SHARE_PLATFORM_DETAILS = [{
  id: 'facebook',
  shareUrl: 'https://www.facebook.com/sharer/sharer.php?u='
}, {
  id: 'twitter',
  shareUrl: 'https://twitter.com/intent/tweet?url='
}, {
  id: 'copylink',
  shareUrl: null
}];
export var SEARCH_TYPES = {
  athletes: 'athletes',
  news: 'news',
  videos: 'videos',
  pages: 'pages'
};
export var isSearchType = function isSearchType(value) {
  return typeof value === 'string' && Object.values(SEARCH_TYPES).includes(value);
};
export var ALERT_STRINGS = {
  duplicateCompetition: "You're already entered into this competition - but don't worry, we've made sure you're signed up."
};